import React from 'react';
import { Heart } from 'lucide-react';
import { useFavorites } from '../context/FavoritesContext';

export default function FavoriteButton({ business, businessId, size = 'md', className = '', showLabel = false }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  
  // Support both business object and businessId
  const id = business?.id || businessId;
  const businessData = business || { id: businessId };
  const isFav = isFavorite(id);

  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  const iconSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  const handleClick = (e) => {
    e.stopPropagation();
    toggleFavorite(businessData);
  };

  return (
    <button
      onClick={handleClick}
      className={`${showLabel ? 'px-4 w-auto' : sizes[size]} rounded-full flex items-center justify-center gap-2 transition-all shadow-md hover:shadow-lg active:scale-95 ${
        isFav
          ? 'bg-red-500 text-white'
          : 'bg-white text-gray-400 hover:text-red-500'
      } ${className}`}
      data-testid={`favorite-button-${id}`}
      aria-label={isFav ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
    >
      <Heart
        className={`${iconSizes[size]} ${isFav ? 'fill-current' : ''}`}
      />
      {showLabel && (
        <span className="text-sm font-medium pr-1">
          {isFav ? 'Salvo' : 'Salvar'}
        </span>
      )}
    </button>
  );
}
